
import React, { Component } from 'react';
import {connect} from 'react-redux'
// import {compose} from 'redux'
import { Box } from 'reactjs-admin-lte'
import { Radio, ControlLabel, Row, Col, FormGroup, FormControl, ButtonGroup,Button, ButtonToolbar, Modal } from 'react-bootstrap'
// import { tableHelper } from './helpers'
import ReactPaginate from 'react-paginate'
import FontAwesome from 'react-fontawesome'
// import Select from 'react-select'
// import DatePicker from '../../component/element/DatePicker'
import SelectObject from '../../component/element/SelectObject'
import ReportStore from '../../stores/ReportStore';
import JobControlBoardTable from '../workdoc/jobcontrol/JobControlBoardTable'
import StatusControlBoardTable from '../workdoc/statuscontrol/StatusControlBoardTable'
import IframeModal from '../../component/element/IframeModal'
import ConfigOfficeWorkflow from '../admin/ConfigOfficeWorkflow'
import ConfigMechanicWorkflow from '../admin/ConfigMechanicWorkflow'
import withSizes from 'react-sizes'
// const mockJson = {
//   jobState: {
//     0: 'รอเริ่มงาน',
//     1: 'กำลังซ่อม',
//     2: 'ซ่อมเสร็จในขั้นตอน',
//     3: 'หยุดชั่วคราว',
//   },

//   workerList: [
//     {
//       workerId: '1xx',
//       workerName: 'แจ๊ค'
//     },
//     {
//       workerId: '2xx',
//       workerName: 'อ๋อม'
//     }
//   ],

//   summary: {
//     missingCount: 16,
//     appointmentCount: 10,
//     noShowCount: 20,
//     finishCount: 0,
//     unassignCount: 10,
//   },

//   dataList: [
//     {
//       workNo: 'SR304.638/2559',
//       registrationNo: 'กข-1234',
//       brandModel: 'Honda Civic',
//       colorCode: '',
//       startDate: '26/08/2560',
//       finishDate: '28/08/2560',
//       deliverDate: '29/08/2560',
//       fixLevel: 'M ซ่อมกลาง',
//       dismanlingState: '1',
//       hitState: '0',
//       trapState: '1',
//       groundState: '1',
//       mixColorState: '2',
//       paintState: '3',
//       assemblyState: '0',
//       polishState: '0',
//       cleanState: '1',
//       qcState: '1',
//       jobState: '0',
//       parkingStatus: '1'
//     },
//     {
//       workNo: 'SR304.647/2559',
//       registrationNo: 'คผ-1888',
//       brandModel: 'Toyota Corona',
//       colorCode: '',
//       startDate: '26/08/2560',
//       finishDate: '28/08/2560',
//       deliverDate: '29/08/2560',
//       fixLevel: 'M ซ่อมกลาง',
//       dismanlingState: '1',
//       hitState: '3',
//       trapState: '3',
//       groundState: '3',
//       mixColorState: '2',
//       paintState: '3',
//       assemblyState: '0',
//       polishState: '0',
//       cleanState: '3',
//       qcState: '1',
//       jobState: '2',
//       parkingStatus: '1'
//     }
//   ]
// };


// const NO_SHOW = 1
// const PRESENT_APPOINTMENT = 2
// const NOT_YET_APPOINTMENT = 3
// const JOB_DONE = 4


// const jobStyle = {
//   0: { background: 'rgb(227, 186, 130)' },
//   1: { background: 'rgb(252, 254, 206)' },
//   2: { background: 'rgb(125, 195, 150)' },
//   3: { background: 'rgb(170, 195, 220)' },
// }

const STATE_MODE = {
  STATE_PERCENTAGE_MODE : 1,
  STATE_CHECK_MODE : 2,
}

// const WORK_STATE_DEFAUILT = [{ title: 'รื้อ', field: 'dismanlingState' },
//         { title: 'เคาะ', field: 'hitState' },
//         { title: 'โป๊ว', field: 'trapState' },
//         { title: 'พื้น', field: 'groundState' },
//         { title: 'ผสมสี', field: 'mixColorState' },
//         { title: 'พ่น', field: 'paintState' },
//         { title: 'ประกอบ', field: 'assemblyState' },
//         { title: 'ขัดสี', field: 'polishState' },
//         { title: 'ล้าง', field: 'cleanState' },
//         { title: 'QC', field: 'qcState' }]

class ReportJobControlBoard extends Component {

  constructor(...args) {
    super(...args)
    this.state = {
      pageCount: 1,
      activePage: 1,
      loading: false,
      query: '',
      workerId: '0',
      parkingStatus: '',
      stateDisplay:STATE_MODE.STATE_CHECK_MODE ,
      showConfigOffice:false,
      showConfigMechanic:false
    }
    this.workState = []
  }

  componentDidMount() {
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }    
    this.loadWorkList()
  }

  componentWillReceiveProps(newProps){
    if(this.props.siteLocation.locationCode!==newProps.siteLocation.locationCode){
      this.loadWorkList()
    }
  }

  loadWorkList() {
    let no_show_other_state = false
    this.setState({ loading: true })
    if (this.props.control==='workJobOffice') {
      ReportStore.loadReportWorkOfficeControl((result)=> {
        this.workState = result.work_state
        if (result.no_show_other_state!==undefined&&result.no_show_other_state)
          no_show_other_state = true
        else
          no_show_other_state = false
        this.setState({ loading: false })     
        this.refs.jcbTable.getWrappedInstance().loadData(result.data,this.workState) 
        this.refs.jcbTable.getWrappedInstance().onHideFilterNoSelChange(no_show_other_state) 
        this.refs.jcbTable.getWrappedInstance().onSetOrderBy(result.order_by,result.direction) 
      },()=>{
        this.setState({loading:false})
      })
    }else if (this.props.control==='recheck') {
      ReportStore.loadReportRecheckControl((result)=> {
        this.workState = result.work_state
        if (result.no_show_other_state!==undefined&&result.no_show_other_state)
          no_show_other_state = true
        else
          no_show_other_state = false
        this.setState({ loading: false })     
        this.refs.jcbTable.getWrappedInstance().loadData(result.data,this.workState) 
        this.refs.jcbTable.getWrappedInstance().onHideFilterNoSelChange(no_show_other_state) 
        this.refs.jcbTable.getWrappedInstance().onSetOrderBy(result.order_by,result.direction) 
      },()=>{
        this.setState({loading:false})
      })
    }else if (this.props.control==='pm') {
      ReportStore.loadReportControlBoard(this.props.control,(result)=> {
        this.workState = result.work_state
        if (result.no_show_other_state!==undefined&&result.no_show_other_state)
          no_show_other_state = true
        else
          no_show_other_state = false
        this.setState({ loading: false })     
        this.refs.jcbTable.getWrappedInstance().loadData(result.data,this.workState) 
        this.refs.jcbTable.getWrappedInstance().onHideFilterNoSelChange(no_show_other_state) 
        this.refs.jcbTable.getWrappedInstance().onSetOrderBy(result.order_by,result.direction) 
      },()=>{
        this.setState({loading:false})
      })
    } else {
      ReportStore.loadReportWorkJobControl((result)=> {
        this.workState = result.work_state
        if (result.no_show_other_state!==undefined&&result.no_show_other_state)
          no_show_other_state = true
        else
          no_show_other_state = false  
        this.setState({ loading: false })     
        this.refs.jcbTable.getWrappedInstance().loadData(result.data,this.workState)
        this.refs.jcbTable.getWrappedInstance().onSetVisibleField(result.visible_field) 
        this.refs.jcbTable.getWrappedInstance().onHideFilterNoSelChange(no_show_other_state) 
        this.refs.jcbTable.getWrappedInstance().onSetStatusFilter(result.filter_job_status)  
        this.refs.jcbTable.getWrappedInstance().onSetOrderBy(result.order_by,result.direction) 
      },()=>{
        this.setState({loading:false})
      })
    }  
  }

  onSearchClick(){
    this.loadWorkList()
  }

  onLoading() {
    this.setState({ loading: true })
    setTimeout(()=>{
      this.setState({ loading: false })
    },500)
  }

  updateWorkNo(workNo, taskstate) {
    let { data } = this.state
    //console.log('updateWork', data,workNo, taskstate)
    this.refs.jcbTable.getWrappedInstance().updateWorkNo(workNo,taskstate)
    // data.dataList = data.dataList.map((item, index) => {
    //   if (item.work_no === workNo) {
    //     return Object.assign(item, taskstate)
    //   } else {
    //     return item
    //   }
    // })
    // this.setState({ data: data })
  }

  onParkingClick(parkingStatusVal, e) {
    this.setState({
      parkingStatus: parkingStatusVal
    })
  }

  renderParkingRadioButtons() {
    const parkingOptions = [
      {
        label: 'รถจอด',
        value: '1'
      },
      {
        label: 'รถไม่จอด/รอจอด',
        value: '0'
      }
    ]
    const radioList = parkingOptions.map((parkingStatus, i) => (
      <Radio
        key={i}
        name="parkingStatus"
        inline
        value={parkingStatus.value}
        onClick={this.onParkingClick.bind(this, parkingStatus.value)}
      >
        {parkingStatus.label}
      </Radio>
    ))
    return (
      <FormGroup>
        {radioList}
      </FormGroup>
    )
  }

  onDateChange(dateString, dateMoment) {

  }

  renderPrint() {
    return (
      <Button
        bsStyle={null}
        className='bg-blue'
        onClick={this.props.onPrintTable}
      >
        <FontAwesome name='print' />{' '}พิมพ์รายงาน
        </Button>
    )
  }

  onQueryChange(e) {
    this.setState({
      query: e.target.value
    })
  }

  renderSearchBox() {
    return (
      <FormGroup >
        <ControlLabel>ค้นหา</ControlLabel>
        {' '}
        <FormControl
          value={this.state.query}
          type="text"
          placeholder=""
          bsSize="sm"
          onChange={this.onQueryChange.bind(this)}
        />
      </FormGroup>
    )
  }

  onWorkerSelect(val) {
    this.setState({
      workerId: val.value
    })
  }

  renderSelectWorker() {
    return (
      <FormGroup style={{ width: '190px' }}>
        <SelectObject
          placeholder="เลือกเจ้าหน้าที่รับรถ"
          value={this.state.workerId}
          objectList={this.state.data.workerList}
          onChange={this.onWorkerSelect.bind(this)}
        />
      </FormGroup>
    )
  }

  onSearchButtonClick(e) {
    // do sth with this.state.query
  }

  onPrintClick(e) {
    if (this.props.mode!=='status') {
      this.refs.jcbTable.getWrappedInstance().getFilterTb((result,result2,hideFilterNoSel)=>{
        let filter_tb = "";
        let filter_status = "";
        this.workState.map((item,index)=>{
          if(typeof result[item.value]!=='undefined')
            filter_tb += '&'+item.value+"="+result[item.value]
          return item
        })
        if (result2.length>0)
          filter_status = '&status='+result2.join()
        let url = ''
        if (process.env.NODE_ENV == "development") {
          url  = './?startPage=PrintReportJobControlBoard&control='+this.props.control+filter_tb+filter_status+'&hideFilterNoSel='+hideFilterNoSel
        } else{
          url = './pdf/v2/?startPage=PrintReportJobControlBoard&control='+this.props.control+filter_tb+filter_status+'&hideFilterNoSel='+hideFilterNoSel
        }
        this.refs.iframe.loadUrl(url)  
      })
    }  
  }

  onRowClick(row) {
    
    if (this.props.onRowClick !== undefined) {
      this.props.onRowClick(row,this.workState)
    }
  }

  onStateMenuItemSelect(value){
    
    this.setState({stateDisplay:value})
  }

  onFilterChange(){

  }

  onSearchKeyPress(){

  }

  onSearchKeyPress(){

  }

 
  getFilterOptions(){
    return [{label:'บริษัทประกัน',value:'insurer'},{label:"ลูกค้า/บริษัท",value:"client"}]
  }

  

  onPageChange(page) {

  }

  onBack() {
    if (this.props.onBack!==undefined)
      this.props.onBack()
  }

  renderPaging() {
    let {messages} = this.props
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={messages['Previous']}
            nextLabel={messages['Next']}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </Col>
      </Row>
    )
  }

  render() {
    let { show,messages,mode } = this.props
    const title = (this.props.control=='workJobOffice'?messages['Work Internal Job Control Table']:this.props.control==='recheck'?messages['Check repair information table']:messages['Work Job Control Table'])
    if (show === undefined)
      show = true
    
    return (
      <div style={{ display: (show) ? 'block' : 'none' }}>
        <Box loading={this.state.loading}>
          <Box.Header border={true}>
            <Box.Title>{title} {this.props.control=='workJobOffice'?<FontAwesome onClick={()=>{this.setState({showConfigOffice:true})}} style={{cursor:'pointer'}} name='cog' />:<FontAwesome onClick={()=>{this.setState({showConfigMechanic:true})}} style={{cursor:'pointer'}} name='cog' />}</Box.Title>
            <Box.Tools>
              <ButtonToolbar>
                <ButtonGroup>
                    <Button 
                      className='btn-box-tool bg-maroon'
                      onClick={this.onPrintClick.bind(this)}
                      style={{display:(this.props.mode!=='status'?'':'none')}}
                    >
                      <FontAwesome name='print' />&nbsp;{messages['Print']}</Button>
                </ButtonGroup>               
              </ButtonToolbar>
            </Box.Tools>
         </Box.Header>
          <Box.Body>
            {mode==='status'
            ?
            <StatusControlBoardTable
              ref='jcbTable' 
              mode='status'
              control={this.props.control}
              jobStyle={this.props.jobStyle}
              jobState={this.props.jobState}
              isMobile={this.props.isMobile}
              onSearchClick={this.onSearchClick.bind(this)}
              onLoading={this.onLoading.bind(this)}
              onRowClick={this.onRowClick.bind(this)}
            />
            :
            <JobControlBoardTable 
              ref='jcbTable' 
              defaultHeaderTitles={this.props.defaultHeaderTitles}
              control={this.props.control}
              showCheckMechanic={this.props.showCheckMechanic}
              jobStyle={this.props.jobStyle}
              jobState={this.props.jobState}
              isMobile={this.props.isMobile}
              onSearchClick={this.onSearchClick.bind(this)}
              onLoading={this.onLoading.bind(this)}
              onRowClick={this.onRowClick.bind(this)}
              onBack={this.onBack.bind(this)}
            />}
            {mode==='status'?'':this.renderPaging()}
          </Box.Body>
          <IframeModal ref='iframe' title={messages['Print Document']} />
        </Box>
        <Modal bsSize='large' show={this.state.showConfigOffice} onHide={()=>{this.setState({showConfigOffice:false})}} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{messages['Work Internal Job Control Table']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ConfigOfficeWorkflow

            />
          </Modal.Body>
        </Modal>
        <Modal bsSize='large' show={this.state.showConfigMechanic} onHide={()=>{this.setState({showConfigMechanic:false})}} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{messages['Work Job Control Table']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ConfigMechanicWorkflow

            />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

ReportJobControlBoard.defaultProps = {
  control: 'workJob',
  showCheckMechanic:true,
  siteLocation:{locationCode:'',locationName:''}
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})
export default ReportJobControlBoard = connect(
    (state) => ({messages: state.message.view.report.ReportJobControlBoard,siteLocation:state.siteLocation}),null,null,{withRef:true},
    withSizes(mapSizesToProps)
)(ReportJobControlBoard);




// WEBPACK FOOTER //
// ./src/view/report/ReportJobControlBoard.js